module.exports = __webpack_public_path__ + "img/cohort.e07fd51.svg";